var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightCircuit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 629,
    viewBox: "0 0 383 629",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.722 0.513684C270.349 -0.413213 268.484 -0.0511943 267.557 1.32125C266.63 2.69369 266.992 4.55941 268.364 5.48631C269.737 6.41321 271.602 6.05121 272.529 4.67877C273.456 3.30632 273.094 1.44058 271.722 0.513684Z",
    fill: "url(#paint0_linear_1857_4584)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.833 543.54L117.345 547.609L114.195 549.53L117.809 550.269L119.648 553.931L120.137 549.862L123.287 547.941L119.672 547.202L117.833 543.54Z",
    fill: "#15BFFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M303.554 436L291.614 426.544H193.978L172.273 414.794H86.043V414H172.472L194.181 425.754H291.89L304.043 435.378L303.554 436Z",
    fill: "url(#paint1_linear_1857_4584)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M302.183 438.355C303.482 439.38 305.373 439.16 306.398 437.86C307.423 436.561 307.203 434.67 305.904 433.645C304.604 432.62 302.713 432.839 301.688 434.144C300.663 435.444 300.883 437.334 302.183 438.359V438.355Z",
    fill: "url(#paint2_linear_1857_4584)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M307.556 425L295.648 415.544H198.24L176.586 403.794H85.043V403H176.784L198.438 414.749H295.919L308.043 424.378L307.556 425Z",
    fill: "url(#paint3_linear_1857_4584)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.902 422.647C310.201 423.671 310.425 425.56 309.396 426.859C308.372 428.158 306.483 428.382 305.184 427.353C303.885 426.324 303.661 424.44 304.69 423.141C305.714 421.842 307.603 421.618 308.902 422.647Z",
    fill: "url(#paint4_linear_1857_4584)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.063 344L120.978 343.954L95.5893 330.492H24.043V329.682H95.7837L95.8695 329.728L121.253 343.19L153.325 342.945L172.848 319H278.676L300.363 330.973H395.043V331.778H300.164L278.477 319.805H173.214L153.696 343.75L121.063 344Z",
    fill: "url(#paint5_linear_1857_4584)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.172 329L121.086 328.954L95.6694 315.492H24.043V314.682H95.8639L95.9499 314.728L121.362 328.19L153.47 327.95L173.014 304H276.043V304.805H173.381L153.841 328.755L121.172 329Z",
    fill: "url(#paint6_linear_1857_4584)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.043 308C277.7 308 279.043 306.657 279.043 305C279.043 303.343 277.7 302 276.043 302C274.386 302 273.043 303.343 273.043 305C273.043 306.657 274.386 308 276.043 308Z",
    fill: "url(#paint7_linear_1857_4584)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M179.043 272H83.7695L61.8952 258.882H25.043V258H62.0957L83.9701 271.118H179.043V272Z",
    fill: "url(#paint8_linear_1857_4584)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M179.043 267C180.698 267 182.043 268.345 182.043 270C182.043 271.655 180.698 273 179.043 273C177.388 273 176.043 271.655 176.043 270C176.043 268.345 177.388 267 179.043 267Z",
    fill: "url(#paint9_linear_1857_4584)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M242.919 294H193.773L179.554 282.152H82.1656L60.5163 269.829H24.043V269H60.7147L82.3641 281.324H179.825L194.044 293.171H242.644L256.123 281.943H305.043V282.771H256.398L242.919 294Z",
    fill: "url(#paint10_linear_1857_4584)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M305.108 285.07C306.744 284.805 307.855 283.265 307.59 281.629C307.325 279.994 305.784 278.882 304.149 279.147C302.513 279.412 301.402 280.953 301.667 282.588C301.932 284.224 303.473 285.335 305.108 285.07Z",
    fill: "url(#paint11_linear_1857_4584)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.904 233H30.043V232.244H102.707L124.243 221H218.043V221.756H124.44L102.904 233Z",
    fill: "url(#paint12_linear_1857_4584)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M219.043 218C220.698 218 222.043 219.345 222.043 221C222.043 222.655 220.698 224 219.043 224C217.388 224 216.043 222.655 216.043 221C216.043 219.345 217.388 218 219.043 218Z",
    fill: "url(#paint13_linear_1857_4584)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M126.485 162L126.043 161.347L186.114 120.568L197.099 98.8236L197.184 98.7691L292.601 34L293.043 34.6534L197.708 99.3681L186.723 121.108L186.642 121.167L126.485 162Z",
    fill: "url(#paint14_linear_1857_4584)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M289.364 32.5137C290.737 31.5868 292.602 31.9488 293.529 33.3212C294.456 34.6937 294.094 36.5594 292.722 37.4863C291.349 38.4132 289.484 38.0512 288.557 36.6788C287.63 35.3063 287.992 33.4406 289.364 32.5137Z",
    fill: "url(#paint15_linear_1857_4584)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M165.413 187L165.043 186.307L229.021 151.707L240.379 134L241.043 134.426L229.572 152.306L229.482 152.351L165.413 187Z",
    fill: "url(#paint16_linear_1857_4584)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M237.52 133.376C238.419 131.983 240.274 131.582 241.667 132.477C243.06 133.372 243.461 135.231 242.566 136.624C241.671 138.017 239.812 138.418 238.419 137.523C237.026 136.628 236.624 134.769 237.52 133.376Z",
    fill: "url(#paint17_linear_1857_4584)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.776 184L97.043 183.687L106.855 160.001L106.956 159.932L159.597 124L160.043 124.663L107.497 160.53L97.776 184Z",
    fill: "url(#paint18_linear_1857_4584)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M157.584 121.599C159.186 120.518 161.362 120.94 162.444 122.541C163.525 124.143 163.103 126.319 161.502 127.401C159.9 128.482 157.724 128.06 156.642 126.459C155.561 124.857 155.983 122.681 157.584 121.599Z",
    fill: "url(#paint19_linear_1857_4584)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M218.344 214H145.043V213.307H218.145L239.811 203H356.043V203.693H240.01L218.344 214Z",
    fill: "url(#paint20_linear_1857_4584)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M356.043 200C357.698 200 359.043 201.345 359.043 203C359.043 204.655 357.698 206 356.043 206C354.388 206 353.043 204.655 353.043 203C353.043 201.345 354.388 200 356.043 200Z",
    fill: "url(#paint21_linear_1857_4584)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M166.043 243H135.043V244H166.043V243Z",
    fill: "url(#paint22_linear_1857_4584)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M165.043 246C166.7 246 168.043 244.657 168.043 243C168.043 241.343 166.7 240 165.043 240C163.386 240 162.043 241.343 162.043 243C162.043 244.657 163.386 246 165.043 246Z",
    fill: "url(#paint23_linear_1857_4584)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M116.965 239H24.043V238.293H116.694L125.547 232H260.043V232.711H125.818L116.965 239Z",
    fill: "url(#paint24_linear_1857_4584)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M259.043 235C260.698 235 262.043 233.656 262.043 232C262.043 230.345 260.698 229 259.043 229C257.388 229 256.043 230.345 256.043 232C256.043 233.656 257.388 235 259.043 235Z",
    fill: "url(#paint25_linear_1857_4584)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M201.043 256H103.961L87.2489 248.668H24.043V248H87.4432L87.5291 248.038L104.151 255.332H201.043V256Z",
    fill: "url(#paint26_linear_1857_4584)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M201.043 259C202.698 259 204.043 257.656 204.043 256C204.043 254.345 202.698 253 201.043 253C199.388 253 198.043 254.345 198.043 256C198.043 257.656 199.388 259 201.043 259Z",
    fill: "url(#paint27_linear_1857_4584)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M242.355 602.719L240.641 535.508L147.772 449.352L148.31 448.773L241.423 535.155L243.141 602.701L242.355 602.719Z",
    fill: "url(#paint28_linear_1857_4584)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M239.781 602.638C239.822 604.275 241.183 605.568 242.819 605.527C244.455 605.486 245.748 604.126 245.708 602.489C245.667 600.853 244.306 599.56 242.67 599.601C241.033 599.641 239.741 601.002 239.781 602.638Z",
    fill: "url(#paint29_linear_1857_4584)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M160.011 616.751H159.22L159.31 582.766L159.423 582.653L199.307 541.788L198.15 496.298L198.937 496.275L200.103 542.1L160.097 583.091L160.011 616.751Z",
    fill: "url(#paint30_linear_1857_4584)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M156.65 616.593C156.65 618.229 157.97 619.563 159.607 619.563C161.243 619.563 162.577 618.243 162.577 616.607C162.577 614.97 161.257 613.637 159.62 613.637C157.984 613.637 156.65 614.957 156.65 616.593Z",
    fill: "url(#paint31_linear_1857_4584)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M197.272 626.131L196.639 601.282L241.274 555.553L241.835 556.104L197.434 601.594L198.058 626.113L197.272 626.131Z",
    fill: "url(#paint32_linear_1857_4584)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M194.701 626.05C194.742 627.687 196.102 628.98 197.739 628.939C199.375 628.898 200.668 627.538 200.627 625.901C200.587 624.265 199.226 622.972 197.59 623.013C195.953 623.053 194.66 624.414 194.701 626.05Z",
    fill: "url(#paint33_linear_1857_4584)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M329.744 512.445L284.634 470.595L204.766 472.529L204.649 472.421L162.983 433.766L163.521 433.188L205.069 471.734L284.937 469.799L285.05 469.907L330.282 511.867L329.744 512.445Z",
    fill: "url(#paint34_linear_1857_4584)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M327.892 514.226C329.089 515.338 330.965 515.27 332.082 514.067C333.194 512.869 333.126 510.993 331.924 509.877C330.726 508.765 328.85 508.833 327.733 510.035C326.621 511.233 326.689 513.109 327.892 514.226Z",
    fill: "url(#paint35_linear_1857_4584)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M299.033 515.375L280.047 497.759L249.023 498.51L220.485 472.038L221.023 471.459L249.326 497.714L280.35 496.964L299.571 514.797L299.033 515.375Z",
    fill: "url(#paint36_linear_1857_4584)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M297.179 517.157C298.377 518.269 300.252 518.201 301.369 516.999C302.481 515.801 302.413 513.925 301.211 512.808C300.013 511.696 298.137 511.764 297.02 512.967C295.908 514.165 295.976 516.041 297.179 517.157Z",
    fill: "url(#paint37_linear_1857_4584)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M288.748 554.449L263.542 531.069L262.715 498.558L263.501 498.535L264.324 530.717L289.286 553.87L288.748 554.449Z",
    fill: "url(#paint38_linear_1857_4584)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M286.891 556.235C288.088 557.347 289.964 557.28 291.081 556.077C292.193 554.879 292.125 553.003 290.923 551.887C289.725 550.775 287.849 550.842 286.732 552.045C285.62 553.243 285.688 555.119 286.891 556.235Z",
    fill: "url(#paint39_linear_1857_4584)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M114.941 578.602L114.376 578.051L137.711 554.146L137.869 554.142L188.602 552.912L188.625 553.703L138.05 554.928L114.941 578.602Z",
    fill: "url(#paint40_linear_1857_4584)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M112.639 576.153C111.496 577.324 111.518 579.2 112.689 580.343C113.86 581.487 115.736 581.464 116.879 580.294C118.023 579.123 118 577.247 116.83 576.103C115.659 574.959 113.783 574.982 112.639 576.153Z",
    fill: "url(#paint41_linear_1857_4584)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M145.32 358L145.043 357.262L170.272 348H231.043V348.792H170.413L145.32 358Z",
    fill: "url(#paint42_linear_1857_4584)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M231.043 345C232.698 345 234.043 346.344 234.043 348C234.043 349.655 232.698 351 231.043 351C229.388 351 228.043 349.655 228.043 348C228.043 346.344 229.388 345 231.043 345Z",
    fill: "url(#paint43_linear_1857_4584)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M193.043 371H173.934L173.828 370.907L160.043 358.62L160.544 358L174.218 370.188H193.043V371Z",
    fill: "url(#paint44_linear_1857_4584)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M193.043 374C194.698 374 196.043 372.655 196.043 371C196.043 369.344 194.698 368 193.043 368C191.388 368 190.043 369.344 190.043 371C190.043 372.655 191.388 374 193.043 374Z",
    fill: "url(#paint45_linear_1857_4584)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M264.578 409H215.163L200.866 396.85H103.043V396H201.138L215.435 408.145H264.306L277.855 396.63H327.043V397.485H278.132L264.578 409Z",
    fill: "url(#paint46_linear_1857_4584)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M326.927 400.599C328.759 400.165 329.892 398.329 329.458 396.497C329.024 394.665 327.187 393.532 325.356 393.966C323.524 394.4 322.391 396.237 322.825 398.069C323.259 399.9 325.096 401.033 326.927 400.599Z",
    fill: "url(#paint47_linear_1857_4584)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M264.578 252H215.163L200.866 239.85H103.043V239H201.138L215.435 251.145H264.306L277.855 239.635H327.043V240.485H278.132L264.578 252Z",
    fill: "url(#paint48_linear_1857_4584)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M326.332 243.041C327.944 242.659 328.941 241.043 328.559 239.43C328.177 237.818 326.561 236.821 324.949 237.203C323.336 237.585 322.339 239.201 322.721 240.814C323.103 242.426 324.72 243.423 326.332 243.041Z",
    fill: "url(#paint49_linear_1857_4584)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M222.452 383H173.278L159.05 371.721H61.5605L16.043 333.607L16.544 333L61.8449 370.927H159.321L173.549 382.207H222.181L235.555 371.603L236.043 372.224L222.452 383Z",
    fill: "url(#paint50_linear_1857_4584)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M223.043 389H173.955L159.713 377.547H62.1234L17.043 338.612L17.549 338L62.4126 376.742H159.984L174.226 388.199H223.043V389Z",
    fill: "url(#paint51_linear_1857_4584)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M240.533 376L240.043 375.346L253.717 364H274.043V364.835H253.994L240.533 376Z",
    fill: "url(#paint52_linear_1857_4584)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M274.543 368C276.474 368 278.043 366.431 278.043 364.5C278.043 362.569 276.474 361 274.543 361C272.612 361 271.043 362.569 271.043 364.5C271.043 366.431 272.612 368 274.543 368Z",
    fill: "url(#paint53_linear_1857_4584)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M155.043 391H134.721L121.043 380.595L121.533 380L134.994 390.238H155.043V391Z",
    fill: "url(#paint54_linear_1857_4584)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M155.043 393C156.698 393 158.043 391.655 158.043 390C158.043 388.345 156.698 387 155.043 387C153.388 387 152.043 388.345 152.043 390C152.043 391.655 153.388 393 155.043 393Z",
    fill: "url(#paint55_linear_1857_4584)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M22.052 223L22.043 222.224L103.716 221.404L133.738 197.581H133.874L218.818 196.729L238.833 180.847L238.969 180.843L323.034 180L323.043 180.78L239.114 181.623L219.099 197.505L182.367 197.871L134.019 198.357L103.997 222.18H103.861L22.052 223Z",
    fill: "url(#paint56_linear_1857_4584)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M323.073 184C324.729 183.982 326.061 182.627 326.043 180.97C326.024 179.314 324.67 177.982 323.013 178C321.357 178.018 320.025 179.373 320.043 181.03C320.061 182.686 321.416 184.018 323.073 184Z",
    fill: "url(#paint57_linear_1857_4584)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M22.052 212L22.043 211.22L98.4061 210.444L127.542 187.09H127.677L204.933 186.305L230.799 165.569L301.011 163L301.043 163.78L231.092 166.345L205.212 187.085L173.461 187.408L127.821 187.87L98.6902 211.224H98.5548L22.052 212Z",
    fill: "url(#paint58_linear_1857_4584)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M302.153 165.998C303.81 165.938 305.1 164.542 305.041 162.89C304.981 161.233 303.585 159.942 301.933 160.002C300.276 160.061 298.985 161.457 299.045 163.11C299.104 164.767 300.5 166.062 302.153 165.998Z",
    fill: "url(#paint59_linear_1857_4584)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M266.305 188L258.043 181.649L258.534 181L266.573 187.183L291.034 186.931L291.043 187.743L266.305 188Z",
    fill: "url(#paint60_linear_1857_4584)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M290.013 184C291.67 183.982 293.029 185.314 293.043 186.97C293.061 188.627 291.729 189.986 290.073 190C288.416 190.018 287.057 188.686 287.043 187.03C287.025 185.373 288.357 184.014 290.013 184Z",
    fill: "url(#paint61_linear_1857_4584)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M147.505 499L133.767 486.346L117.043 484.721L117.122 484L134.115 485.646L134.208 485.733L148.043 498.479L147.505 499Z",
    fill: "url(#paint62_linear_1857_4584)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M144.951 501.148C146.136 502.305 148.037 502.281 149.191 501.092C150.348 499.907 150.324 498.006 149.135 496.852C147.95 495.695 146.049 495.719 144.895 496.908C143.738 498.093 143.762 499.994 144.951 501.148Z",
    fill: "url(#paint63_linear_1857_4584)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M179.518 496L138.938 460.751H85.043V460H139.239L139.351 460.095L180.043 495.444L179.518 496Z",
    fill: "url(#paint64_linear_1857_4584)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M178.032 498.226C179.261 499.336 181.159 499.241 182.269 498.011C183.379 496.782 183.284 494.884 182.054 493.774C180.825 492.664 178.927 492.759 177.817 493.989C176.707 495.218 176.802 497.116 178.032 498.226Z",
    fill: "url(#paint65_linear_1857_4584)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M221.032 390.226C222.261 391.336 224.159 391.241 225.269 390.011C226.379 388.782 226.284 386.884 225.054 385.774C223.825 384.664 221.927 384.759 220.817 385.989C219.707 387.218 219.802 389.116 221.032 390.226Z",
    fill: "url(#paint66_linear_1857_4584)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M129.188 417.365L128.684 417.969L216.507 491.244L217.011 490.64L129.188 417.365Z",
    fill: "url(#paint67_linear_1857_4584)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M214.122 492.303C215.395 493.365 217.284 493.194 218.346 491.921C219.408 490.648 219.237 488.759 217.964 487.697C216.691 486.635 214.802 486.806 213.74 488.079C212.678 489.352 212.849 491.241 214.122 492.303Z",
    fill: "url(#paint68_linear_1857_4584)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M111.838 411.212L111.334 411.816L199.157 485.092L199.661 484.488L111.838 411.212Z",
    fill: "url(#paint69_linear_1857_4584)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M196.122 487.303C197.395 488.365 199.284 488.194 200.346 486.921C201.408 485.648 201.237 483.759 199.964 482.697C198.691 481.635 196.802 481.806 195.74 483.079C194.678 484.352 194.849 486.241 196.122 487.303Z",
    fill: "url(#paint70_linear_1857_4584)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M155.491 530L21.9398 400.112V358.794L0.0565488 359.078L0.0429688 358.289L22.7312 358V399.779L156.043 529.436L155.491 530Z",
    fill: "url(#paint71_linear_1857_4584)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M154.799 531.289C155.786 532.254 157.372 532.235 158.332 531.244C159.297 530.257 159.278 528.671 158.287 527.711C157.3 526.746 155.714 526.765 154.754 527.756C153.789 528.743 153.808 530.329 154.799 531.289Z",
    fill: "url(#paint72_linear_1857_4584)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M148.043 115L154.809 87.9101L154.923 87.8241L269.568 3L270.043 3.63388L155.512 88.3719L149.35 113.044L257.8 32.8066L258.279 33.436L148.043 115Z",
    fill: "url(#paint73_linear_1857_4584)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M256.248 30.5967C257.574 29.6043 259.454 29.8787 260.446 31.205C261.439 32.5312 261.164 34.4109 259.838 35.4033C258.512 36.3957 256.632 36.1213 255.64 34.795C254.647 33.4688 254.922 31.5891 256.248 30.5967Z",
    fill: "url(#paint74_linear_1857_4584)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M125.047 106L125.043 105.232L143.803 105.219L158.536 93L159.043 93.5837L144.094 105.987L125.047 106Z",
    fill: "url(#paint75_linear_1857_4584)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M160.984 96.2884C162.247 95.2174 162.402 93.3226 161.331 92.0594C160.26 90.7962 158.366 90.6406 157.102 91.7116C155.839 92.7826 155.684 94.6774 156.755 95.9406C157.826 97.2038 159.72 97.3594 160.984 96.2884Z",
    fill: "url(#paint76_linear_1857_4584)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M137.855 174.413L137.245 173.916L154.31 152.914L154.373 152.878L207.475 121.854L207.873 122.532L154.834 153.524L137.855 174.413Z",
    fill: "url(#paint77_linear_1857_4584)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M208.047 125.239C209.66 124.952 210.734 123.412 210.447 121.799C210.16 120.187 208.62 119.113 207.007 119.4C205.395 119.687 204.321 121.227 204.608 122.839C204.895 124.452 206.435 125.526 208.047 125.239Z",
    fill: "url(#paint78_linear_1857_4584)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7855 201.079L55.3877 200.396L86.3124 182.328L120.623 183.598L186.165 145.301L186.563 145.983L120.822 184.394L86.5112 183.124L55.7855 201.079Z",
    fill: "url(#paint79_linear_1857_4584)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M184.742 143.158C186.157 142.33 187.97 142.81 188.797 144.22C189.625 145.635 189.145 147.448 187.735 148.275C186.32 149.102 184.507 148.623 183.68 147.213C182.853 145.798 183.332 143.985 184.742 143.158Z",
    fill: "url(#paint80_linear_1857_4584)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M169.843 170.416L150.956 167.152L151.092 166.374L169.693 169.588L186.573 159.725L186.971 160.407L169.843 170.416Z",
    fill: "url(#paint81_linear_1857_4584)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M188.138 162.7C189.553 161.872 190.028 160.06 189.201 158.645C188.373 157.23 186.561 156.755 185.146 157.582C183.731 158.41 183.256 160.222 184.083 161.637C184.911 163.052 186.723 163.527 188.138 162.7Z",
    fill: "url(#paint82_linear_1857_4584)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M144.867 78L144.043 77.9161L146.02 60.9524L161.462 47L162.043 47.5519L146.811 61.3145L144.867 78Z",
    fill: "url(#paint83_linear_1857_4584)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M164.137 48.1498C165.323 46.9913 165.347 45.0923 164.193 43.906C163.034 42.7196 161.135 42.6957 159.949 43.8502C158.763 45.0087 158.739 46.9077 159.893 48.0941C161.052 49.2804 162.951 49.3043 164.137 48.1498Z",
    fill: "url(#paint84_linear_1857_4584)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M119.838 111H119.043V55.6889L158.467 14L159.043 14.5515L119.838 56.0106V111Z",
    fill: "url(#paint85_linear_1857_4584)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M11.348 193L11.043 170.614H55.2491L192.492 39L193.043 39.5596L55.5724 171.393H11.8441L12.1445 192.991L11.348 193Z",
    fill: "url(#paint86_linear_1857_4584)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M195.137 41.1485C196.322 39.9908 196.349 38.0916 195.192 36.9064C194.034 35.7211 192.135 35.6937 190.949 36.8515C189.764 38.0092 189.737 39.9084 190.894 41.0936C192.052 42.2789 193.951 42.3063 195.137 41.1485Z",
    fill: "url(#paint87_linear_1857_4584)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M160.137 16.1485C161.322 14.9908 161.349 13.0916 160.192 11.9064C159.034 10.7211 157.135 10.6937 155.949 11.8515C154.764 13.0092 154.737 14.9084 155.894 16.0936C157.052 17.2789 158.951 17.3063 160.137 16.1485Z",
    fill: "url(#paint88_linear_1857_4584)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1857_4584",
    x1: 421.414,
    y1: 107.823,
    x2: 267.573,
    y2: 1.28941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1857_4584",
    x1: 86.043,
    y1: 425,
    x2: 306.255,
    y2: 425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1857_4584",
    x1: 83.8034,
    y1: 435.998,
    x2: 306.645,
    y2: 435.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1857_4584",
    x1: 85.043,
    y1: 414,
    x2: 310.249,
    y2: 414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1857_4584",
    x1: 81.3605,
    y1: 425.002,
    x2: 309.648,
    y2: 425.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1857_4584",
    x1: 24.043,
    y1: 331.5,
    x2: 397.863,
    y2: 331.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1857_4584",
    x1: 24.043,
    y1: 316.5,
    x2: 278.862,
    y2: 316.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1857_4584",
    x1: 21.4637,
    y1: 305,
    x2: 279.043,
    y2: 305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1857_4584",
    x1: 25.043,
    y1: 265,
    x2: 182.307,
    y2: 265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1857_4584",
    x1: 44.7671,
    y1: 270,
    x2: 182.043,
    y2: 270,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1857_4584",
    x1: 24.043,
    y1: 281.5,
    x2: 308.273,
    y2: 281.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1857_4584",
    x1: 56.9087,
    y1: 282.171,
    x2: 307.592,
    y2: 282.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1857_4584",
    x1: 30.043,
    y1: 227,
    x2: 221.261,
    y2: 227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1857_4584",
    x1: 52.5111,
    y1: 221,
    x2: 222.047,
    y2: 221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1857_4584",
    x1: 123.466,
    y1: 157.621,
    x2: 298.604,
    y2: 37.0032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1857_4584",
    x1: 139.672,
    y1: 139.823,
    x2: 293.513,
    y2: 33.2894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1857_4584",
    x1: 163.192,
    y1: 182.966,
    x2: 245.949,
    y2: 137.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1857_4584",
    x1: 169.684,
    y1: 173.873,
    x2: 242.498,
    y2: 133.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1857_4584",
    x1: 93.3411,
    y1: 178.282,
    x2: 166.451,
    y2: 128.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1857_4584",
    x1: 88.4318,
    y1: 173.747,
    x2: 162.42,
    y2: 122.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1857_4584",
    x1: 145.043,
    y1: 208.5,
    x2: 359.28,
    y2: 208.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1857_4584",
    x1: 170.242,
    y1: 203,
    x2: 359.047,
    y2: 203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1857_4584",
    x1: 135.043,
    y1: 243.506,
    x2: 168.812,
    y2: 243.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1857_4584",
    x1: 133.241,
    y1: 243,
    x2: 168.043,
    y2: 243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1857_4584",
    x1: 24.043,
    y1: 235.502,
    x2: 262.854,
    y2: 235.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1857_4584",
    x1: 19.9942,
    y1: 232,
    x2: 262.043,
    y2: 232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1857_4584",
    x1: 24.043,
    y1: 251.998,
    x2: 203.863,
    y2: 251.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1857_4584",
    x1: 22.0765,
    y1: 256,
    x2: 204.038,
    y2: 256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1857_4584",
    x1: 184.23,
    y1: 441.446,
    x2: 218.722,
    y2: 610.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1857_4584",
    x1: 208.848,
    y1: 436.425,
    x2: 243.339,
    y2: 605.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1857_4584",
    x1: 168.048,
    y1: 502.441,
    x2: 190.669,
    y2: 613.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1857_4584",
    x1: 137.592,
    y1: 508.653,
    x2: 160.213,
    y2: 619.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1857_4584",
    x1: 213.455,
    y1: 561.226,
    x2: 226.103,
    y2: 623.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1857_4584",
    x1: 185.615,
    y1: 566.909,
    x2: 198.263,
    y2: 628.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1857_4584",
    x1: 235.551,
    y1: 418.491,
    x2: 258.176,
    y2: 529.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1857_4584",
    x1: 307.807,
    y1: 403.749,
    x2: 330.432,
    y2: 514.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1857_4584",
    x1: 254.167,
    y1: 464.696,
    x2: 266.346,
    y2: 524.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1857_4584",
    x1: 287.545,
    y1: 457.889,
    x2: 299.719,
    y2: 517.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1857_4584",
    x1: 267.267,
    y1: 497.627,
    x2: 279.712,
    y2: 558.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1857_4584",
    x1: 276.991,
    y1: 495.647,
    x2: 289.435,
    y2: 556.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1857_4584",
    x1: 148.718,
    y1: 551.9,
    x2: 152.918,
    y2: 572.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1857_4584",
    x1: 110.962,
    y1: 559.603,
    x2: 115.162,
    y2: 580.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1857_4584",
    x1: 145.043,
    y1: 353,
    x2: 233.868,
    y2: 353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1857_4584",
    x1: 144.473,
    y1: 347.995,
    x2: 234.043,
    y2: 347.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1857_4584",
    x1: 160.043,
    y1: 364.502,
    x2: 195.804,
    y2: 364.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1857_4584",
    x1: 159.147,
    y1: 371,
    x2: 196.043,
    y2: 371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1857_4584",
    x1: 103.043,
    y1: 402.5,
    x2: 330.295,
    y2: 402.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1857_4584",
    x1: 103.036,
    y1: 397.345,
    x2: 329.511,
    y2: 397.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1857_4584",
    x1: 103.043,
    y1: 245.5,
    x2: 330.295,
    y2: 245.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1857_4584",
    x1: 129.278,
    y1: 240.175,
    x2: 328.615,
    y2: 240.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1857_4584",
    x1: 16.0385,
    y1: 357.998,
    x2: 236.043,
    y2: 357.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6F611E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#9E7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#9D7801",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9A7704",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#957609",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8E7311",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#85701B",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#7A6D27",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736B2F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1857_4584",
    x1: 14.5714,
    y1: 363.502,
    x2: 223.043,
    y2: 363.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1857_4584",
    x1: 240.043,
    y1: 370,
    x2: 277.294,
    y2: 370,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1857_4584",
    x1: 239.965,
    y1: 364.5,
    x2: 278.043,
    y2: 364.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1857_4584",
    x1: 121.043,
    y1: 385.498,
    x2: 158.299,
    y2: 385.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1857_4584",
    x1: 125.401,
    y1: 390,
    x2: 158.043,
    y2: 390,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1857_4584",
    x1: 21.8391,
    y1: 203.056,
    x2: 326.068,
    y2: 199.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1857_4584",
    x1: 18.7209,
    y1: 184.197,
    x2: 326.043,
    y2: 180.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1857_4584",
    x1: 21.8085,
    y1: 188.968,
    x2: 304.086,
    y2: 185.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1857_4584",
    x1: 18.5399,
    y1: 165.975,
    x2: 305.055,
    y2: 162.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1857_4584",
    x1: 274.575,
    y1: 187.921,
    x2: 274.5,
    y2: 180.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6F611E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#9E7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#9D7801",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9A7704",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#957609",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8E7311",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#85701B",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#7A6D27",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736B2F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1857_4584",
    x1: 290.05,
    y1: 187.4,
    x2: 289.977,
    y2: 180.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6F611E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#9E7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#9D7801",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9A7704",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#957609",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8E7311",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#85701B",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#7A6D27",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736B2F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1857_4584",
    x1: 120.809,
    y1: 480.512,
    x2: 144.733,
    y2: 505.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1857_4584",
    x1: 126.294,
    y1: 478.247,
    x2: 149.167,
    y2: 501.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1857_4584",
    x1: 99.3776,
    y1: 446.227,
    x2: 164.894,
    y2: 514.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1857_4584",
    x1: 121.69,
    y1: 437.647,
    x2: 182.178,
    y2: 498.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1857_4584",
    x1: 164.69,
    y1: 329.647,
    x2: 225.178,
    y2: 390.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1857_4584",
    x1: 132.508,
    y1: 414.052,
    x2: 215.386,
    y2: 496.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1857_4584",
    x1: 145.248,
    y1: 419.205,
    x2: 218.175,
    y2: 492.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1857_4584",
    x1: 115.155,
    y1: 407.899,
    x2: 198.033,
    y2: 490.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1857_4584",
    x1: 127.252,
    y1: 414.209,
    x2: 200.179,
    y2: 487.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1857_4584",
    x1: 78.043,
    y1: 358,
    x2: 78.043,
    y2: 531.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1857_4584",
    x1: 156.541,
    y1: 384.509,
    x2: 156.541,
    y2: 531.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1857_4584",
    x1: 143.205,
    y1: 108.738,
    x2: 275.743,
    y2: 6.3534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1857_4584",
    x1: 148.82,
    y1: 116.622,
    x2: 282.385,
    y2: 14.3613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1857_4584",
    x1: 129.034,
    y1: 110.481,
    x2: 156.244,
    y2: 86.2608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1857_4584",
    x1: 133.014,
    y1: 116.646,
    x2: 161.309,
    y2: 92.0274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1857_4584",
    x1: 135.062,
    y1: 170.268,
    x2: 212.104,
    y2: 124.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1857_4584",
    x1: 133.062,
    y1: 166.917,
    x2: 210.105,
    y2: 120.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1857_4584",
    x1: 60.7174,
    y1: 209.302,
    x2: 183.648,
    y2: 135.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1857_4584",
    x1: 65.8494,
    y1: 217.868,
    x2: 188.784,
    y2: 144.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1857_4584",
    x1: 154.075,
    y1: 172.355,
    x2: 185.967,
    y2: 153.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1857_4584",
    x1: 157.3,
    y1: 177.73,
    x2: 189.192,
    y2: 158.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1857_4584",
    x1: 140.189,
    y1: 74.3485,
    x2: 165.882,
    y2: 46.6236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1857_4584",
    x1: 140.935,
    y1: 67.1077,
    x2: 164.169,
    y2: 43.8741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1857_4584",
    x1: 104.988,
    y1: 96.8632,
    x2: 175.652,
    y2: 26.6062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1857_4584",
    x1: 11.043,
    y1: 116.002,
    x2: 195.078,
    y2: 116.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1857_4584",
    x1: 10.4439,
    y1: 38.9977,
    x2: 195.466,
    y2: 38.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1857_4584",
    x1: -24.5561,
    y1: 13.9977,
    x2: 160.466,
    y2: 13.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5427",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#655822",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#766217",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#856A0F",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F7008",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#977503",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9C7800",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9A790E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#94792A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94792E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCircuit);
export default __webpack_public_path__ + "static/media/rightCircuit.531230240bf8ec619ae1dc4e87cd9490.svg";
export { ForwardRef as ReactComponent };